module.exports = __webpack_public_path__ + "static/media/PIT.de1172d3.png";